import { takeLatest } from "redux-saga/effects"

import { apiGeneratorBase } from "../../Utils/saga"
import Creators, { PerksAdminTypes as constants } from "./reducer"
import * as services from "./services"

const actions = {
  getPerksAdminActions: {
    request: Creators.getPerksAdminRequest,
    success: Creators.getPerksAdminSuccess,
    errors: Creators.getPerksAdminFailure
  },
  getPerksAdminFilterOptionsActions: {
    request: Creators.getPerksAdminFilterOptionsRequest,
    success: Creators.getPerksAdminFilterOptionsSuccess,
    errors: Creators.getPerksAdminFilterOptionsFailure,
    withoutErrorNotification: true
  },
  createPerkAdminActions: {
    request: Creators.createPerkAdminRequest,
    success: Creators.createPerkAdminSuccess,
    errors: Creators.createPerkAdminFailure
  },
  updatePerkAdminActions: {
    request: Creators.updatePerkAdminRequest,
    success: Creators.updatePerkAdminSuccess,
    errors: Creators.updatePerkAdminFailure
  },
  deletePerkAdminActions: {
    request: Creators.deletePerkAdminRequest,
    success: Creators.deletePerkAdminSuccess,
    errors: Creators.deletePerkAdminFailure
  },
  togglePerkVisibilityActions: {
    request: Creators.togglePerkVisibilityRequest,
    success: Creators.togglePerkVisibilitySuccess,
    errors: Creators.togglePerkVisibilityFailure
  },
  getPerksManageOrderActions: {
    request: Creators.getPerksManageOrderRequest,
    success: Creators.getPerksManageOrderSuccess,
    errors: Creators.getPerksManageOrderFailure
  },
  reorderPerksActions: {
    request: Creators.reorderPerksRequest,
    success: Creators.reorderPerksSuccess,
    errors: Creators.reorderPerksFailure
  },
  savePerkCommentActions: {
    request: Creators.savePerkCommentRequest,
    success: Creators.savePerkCommentSuccess,
    errors: Creators.savePerkCommentFailure
  },
  deletePerkCommentActions: {
    request: Creators.deletePerkCommentRequest,
    success: Creators.deletePerkCommentSuccess,
    errors: Creators.deletePerkCommentFailure
  }
}

const eventsOptions = {
  [constants.GET_PERKS_ADMIN_REQUEST]: {
    api: services.getPerksAdmin,
    actions: actions.getPerksAdminActions
  },
  [constants.GET_PERKS_ADMIN_FILTER_OPTIONS_REQUEST]: {
    api: services.getPerksAdminFilterOptions,
    actions: actions.getPerksAdminFilterOptionsActions
  },
  [constants.CREATE_PERK_ADMIN_REQUEST]: {
    api: services.createPerkAdmin,
    actions: actions.createPerkAdminActions
  },
  [constants.UPDATE_PERK_ADMIN_REQUEST]: {
    api: services.updatePerkAdmin,
    actions: actions.updatePerkAdminActions
  },
  [constants.DELETE_PERK_ADMIN_REQUEST]: {
    api: services.deletePerkAdmin,
    actions: actions.deletePerkAdminActions
  },
  [constants.TOGGLE_PERK_VISIBILITY_REQUEST]: {
    api: services.togglePerkVisibility,
    actions: actions.togglePerkVisibilityActions
  },
  [constants.GET_PERKS_MANAGE_ORDER_REQUEST]: {
    api: services.getPerksManageOrder,
    actions: actions.getPerksManageOrderActions
  },
  [constants.REORDER_PERKS_REQUEST]: {
    api: services.reorderPerks,
    actions: actions.reorderPerksActions
  },
  [constants.SAVE_PERK_COMMENT_REQUEST]: {
    api: services.savePerkComment,
    actions: actions.savePerkCommentActions
  },
  [constants.DELETE_PERK_COMMENT_REQUEST]: {
    api: services.deletePerkComment,
    actions: actions.deletePerkCommentActions
  }
}

export default function* apiSaga() {
  yield takeLatest(constants.GET_PERKS_ADMIN_REQUEST, (a) =>
    apiGeneratorBase(a, eventsOptions[constants.GET_PERKS_ADMIN_REQUEST])
  )
  yield takeLatest(constants.GET_PERKS_ADMIN_FILTER_OPTIONS_REQUEST, (a) =>
    apiGeneratorBase(a, eventsOptions[constants.GET_PERKS_ADMIN_FILTER_OPTIONS_REQUEST])
  )
  yield takeLatest(constants.CREATE_PERK_ADMIN_REQUEST, (a) =>
    apiGeneratorBase(a, eventsOptions[constants.CREATE_PERK_ADMIN_REQUEST])
  )
  yield takeLatest(constants.UPDATE_PERK_ADMIN_REQUEST, (a) =>
    apiGeneratorBase(a, eventsOptions[constants.UPDATE_PERK_ADMIN_REQUEST])
  )
  yield takeLatest(constants.DELETE_PERK_ADMIN_REQUEST, (a) =>
    apiGeneratorBase(a, eventsOptions[constants.DELETE_PERK_ADMIN_REQUEST])
  )
  yield takeLatest(constants.TOGGLE_PERK_VISIBILITY_REQUEST, (a) =>
    apiGeneratorBase(a, eventsOptions[constants.TOGGLE_PERK_VISIBILITY_REQUEST])
  )
  yield takeLatest(constants.GET_PERKS_MANAGE_ORDER_REQUEST, (a) =>
    apiGeneratorBase(a, eventsOptions[constants.GET_PERKS_MANAGE_ORDER_REQUEST])
  )
  yield takeLatest(constants.REORDER_PERKS_REQUEST, (a) =>
    apiGeneratorBase(a, eventsOptions[constants.REORDER_PERKS_REQUEST])
  )
  yield takeLatest(constants.SAVE_PERK_COMMENT_REQUEST, (a) =>
    apiGeneratorBase(a, eventsOptions[constants.SAVE_PERK_COMMENT_REQUEST])
  )
  yield takeLatest(constants.DELETE_PERK_COMMENT_REQUEST, (a) =>
    apiGeneratorBase(a, eventsOptions[constants.DELETE_PERK_COMMENT_REQUEST])
  )
}
